 /* eslint-disable  @typescript-eslint/no-unused-vars */

import { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { CustomDialog, CustomSwitch, CustomTooltipWithLabel, DashboardHeader, DashboardLoader, downloadFile, FilterLayout, FilterProp, formatRelativeTimeForTable, HorizontalNavbar, LinkButton, renderHeaderActionButtons, SearchBox, SidePopover, TableDashboard, TableDashboardTheme, TableLayout, TableSubHeader, TooltipTheme, useAppDispatch, useAppSelector } from '../../globalUtils/globalExports';
import { Id, toast } from 'react-toastify';
import { cloneDeep, startCase, toLower } from 'lodash';
import { advanceRuleEngineTypes, chargerTypes, clearAdvanceRuleEngineFormRedux, clearDerivedConditionFormRedux, deleteAdvanceRuleEngineRule, exportAdvanceRuleEngineHistoryData, fetchAdvanceRuleEngineRuleHistoryListData, fetchAdvanceRuleEngineRuleListData, fetchDerivedConditionsListData, getAdvanceRuleEngineReducer, getCurrentFiltersValues, getCurrentScreenAppliedFiltersCount, getFilterReducer, getFilterSelectedValue, getReferenceDataReducer, setAdvanceRuleEngineHistoryListTableProps, setAdvanceRuleEngineLayoutView, setAdvanceRuleEngineListTableProps, setDerivedConditionsListTableProps, setFilterData, setTableProps, toggleAdvanceRuleEngineRuleStatus } from '../../rmsReduxStore/reduxExports';
import { useLocation, useNavigate } from 'react-router-dom';
import { IAdvanceRuleEngineHistoryListItem, IAdvanceRuleEngineListItem, IDerivedConditionListItem } from '../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';
import { Box, Chip, Menu, MenuItem, ThemeProvider, Tooltip } from '@mui/material';
import './AdvanceRuleEngineDashboard.css';
import { IconWithTooltip } from '../../globalUtils/globalIcons';
import { NoDataComponentDerivedConditions, NoDataComponentRuleEngine, NoDataComponentRuleEngineHistory } from '../../globalUtils/TableDashboard/TableComponents';
import access from '../../auth/service/AccessControl';
import { AxiosResponse } from 'axios';
import AdvanceRuleEngineGrid from './AdvanceRuleEngineGrid';


const AdvanceRuleEngineDashboard: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { advanceRuleEngineRuleList, advanceRuleEngineListCount, advanceRuleEngineListTableProps, advanceRuleEngineListLoader, advanceRuleEngineRuleHistoryList, advanceRuleEngineHistoryListCount, advanceRuleEngineHistoryListTableProps, derivedConditionsList, derivedConditionsListCount, derivedConditionsListTableProps, advanceRuleEngineLayoutView } = useAppSelector(getAdvanceRuleEngineReducer);
    const advanceRuleEngineListTablePropsRef = useRef(advanceRuleEngineListTableProps);
    const advanceRuleEngineHistoryListTablePropsRef = useRef(advanceRuleEngineHistoryListTableProps);
    const derivedConditionsListTablePropsRef = useRef(derivedConditionsListTableProps);
    const [selectedNav, setSelectedNav] = useState<'advanceRuleEngine' | 'advanceRuleEngineHistory' | 'derivedConditions'>(location?.state?.activeTab ? location?.state?.activeTab : 'advanceRuleEngine');
    const [noChargerDialogOpen, setNoChargerDialogOpen] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [tableWrapHeight, setTableWrapHeight] = useState<number>(0);
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    // const tableRef = useRef<HTMLDivElement>(null);
    const headerWrapRef = useRef<HTMLDivElement>(null);
    const searchWrapRef = useRef<HTMLDivElement>(null);
    const tableWrapRef = useRef<HTMLDivElement>(null);
    const subHeaderRef = useRef<HTMLDivElement>(null);
    const infoTextWrapRef = useRef<HTMLDivElement>(null);
    const [filtersVisible, setFiltersVisible] = useState<boolean>(false);
    const { ruleEngineStatusReferenceData, userReferenceData, chargingStationReferenceData, chargerVisibleIdReferenceData, advanceRuleEngineRuleNameReferenceData } = useAppSelector(getReferenceDataReducer);
    const { screenFilters } = useAppSelector(getFilterReducer);
    const [exportingFile, setExportingFile] = useState<boolean>(false);
    const advanceRuleEngineStatusFilter = getFilterSelectedValue('advanceRuleEngineStatus', 'advanceRuleEngine', false);
    const [selectedChip,setSelectedChip] = useState<string | null >(advanceRuleEngineStatusFilter?.[0]?.id  ?? null);
    const [isDeleteRuleDialogOpen,setIsDeleteRuleDialogOpen] = useState<boolean>(false);
    const deleteRuleIdRef = useRef<string | null>(null);
    const [layoutView,setLayoutView] = useState<string>(advanceRuleEngineLayoutView ?? 'list'); //list or grid
    const [showAllTriggers, setShowAllTriggers] = useState<boolean>(false);

    const derivedConditionStatusRef = [
        {
            id: 'Draft',
            label: 'Draft',
            name: 'Draft',
            value: 'Draft'
        },
        {
            id:'Not Draft',
            label:'Published',
            name:'Published',
            value:'Not Draft'
        }
    ]

    const advanceRuleEngineStatusMapper = {
        Running: {
            title: 'Running',
            icon: 'rule_engine_running_status_icon'
        },
        Stopped: {
            title: 'Stopped',
            icon: 'rule_engine_stopped_status_icon '
        },
        Error: {
            title: 'Error',
            icon: 'rule_engine_error_status_icon'
        },
        Draft: {
            title: 'Draft',
            icon: 'rule_engine_draft_status_icon '
        }
    }

    const handleNullValuesForFields = (value: string) => {
        if (!value) return '-';
        else return value;
    }

    const errorToast = (msg: string): Id => toast.error(msg);
    const successToast = (msg: string): Id => toast.success(msg);


    const renderStatusCell = (params: GridRenderCellParams<GridValidRowModel, Date>) => {
        const rowData = params?.row;
        const [localStatus, setLocalStatus] = useState(rowData?.status === 'Enabled');

        useEffect(() => {
            setLocalStatus(rowData?.status === 'Enabled');
        }, [rowData])

        const handleToggleChange = async (e: React.MouseEvent) => {
            e.stopPropagation();
            // Optimistically toggle the switch
            if (rowData?.runningStatus === 'Draft') {
                errorToast('Rule is in Draft Mode');
                return;
            }
            setLocalStatus(prev => !prev);
            const res = await dispatch(toggleAdvanceRuleEngineRuleStatus({ ruleId: rowData?.id }));
            if (res.status === 200 || res.status === 202) {
                successToast(`Rule ${res?.data?.data?.status}.`);
                layoutCallback(
                    advanceRuleEngineListTablePropsRef?.current?.pageNumber, advanceRuleEngineListTablePropsRef?.current?.pageSize, advanceRuleEngineListTablePropsRef?.current?.view, advanceRuleEngineListTablePropsRef?.current?.sortBy, advanceRuleEngineListTablePropsRef?.current?.order, null, advanceRuleEngineListTablePropsRef?.current?.searchTerm
                )
            } else {
                errorToast(res?.data?.message);
                setLocalStatus(rowData?.status === 'Enabled');
            }
        };
        return (
            <CustomSwitch
                switchId='advance__rule__engine__single__notification__status-switch'
                switchClassName='advance__rule__engine__single__notification__status-switch'
                checked={localStatus}
                switchLabelName={localStatus ? 'Enabled' : 'Disabled'}
                handleClick={handleToggleChange}
                isDisabled={false}
            />
        );
    };

    useEffect(() => {
        advanceRuleEngineListTablePropsRef.current = advanceRuleEngineListTableProps;
    }, [advanceRuleEngineListTableProps])

    useEffect(() => {
        advanceRuleEngineHistoryListTablePropsRef.current = advanceRuleEngineHistoryListTableProps;
    }, [advanceRuleEngineHistoryListTableProps])

    useEffect(() => {
        derivedConditionsListTablePropsRef.current = derivedConditionsListTableProps;
    }, [derivedConditionsListTableProps])

    const headerActionBtns = renderHeaderActionButtons({
        actionBtns:
            [
                {
                    id: 'add_derived_condition',
                    isAccessible: selectedNav === 'derivedConditions',
                    headerActionBtnClick: (): void => {
                        dispatch(clearDerivedConditionFormRedux());
                        navigate('/add-derived-condition', { state: { mode: 'Define' } });
                    }
                },
                {
                    id: 'create_new_rule_btn',
                    isAccessible: selectedNav !== 'derivedConditions',
                    headerActionBtnClick: (): void => {
                        dispatch(clearAdvanceRuleEngineFormRedux()); /// clearing the entire rule engine form redux when create Rule button clicked
                        navigate('/new-rule-advance', { state: { mode: 'Define' } });
                    }
                },
                {
                    id: 'add_filter_btn',
                    isAccessible: true,
                    headerActionBtnClick: (): void => {
                        setFiltersVisible(true);
                    },
                    badgeCount: getCurrentScreenAppliedFiltersCount(selectedNav, selectedNav !== 'advanceRuleEngineHistory')
                },
                {
                    id: 'export_csv_btn',
                    isAccessible: selectedNav === 'advanceRuleEngineHistory',
                    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                    headerActionBtnClick: (event): void => {
                        setExportAnchorEl(event.currentTarget);
                    },
                },
            ]
    });

    const onEditIconClick = (rowData, isAccessible) => {
        if (!isAccessible) return;
        dispatch(clearAdvanceRuleEngineFormRedux());
        navigate('/new-rule-advance', {
            state: {
                ruleId: rowData?.id,
                mode: 'Edit',
                fetchRule: true
            }
        });
    }

    const onViewIconClick = (rowData, isAccessible) => {
        if (!isAccessible) return;
        dispatch(clearAdvanceRuleEngineFormRedux());
        navigate('/new-rule-advance', {
            state: {
                ruleId: rowData?.id,
                mode: 'View',
                fetchRule: true
            }
        });
    }

    const onEditDerivedConditionClick = (rowData, isAccessible) => {
        if (!isAccessible) return;
        dispatch(clearDerivedConditionFormRedux());
        navigate('/add-derived-condition', {
            state: {
                derivedConditionId: rowData?.id,
                mode: 'Edit'
            }
        });
    }

    const onViewDerivedConditionClick = (rowData, isAccessible) => {
        if (!isAccessible) return;
        dispatch(clearDerivedConditionFormRedux());
        navigate('/add-derived-condition', {
            state: {
                derivedConditionId: rowData?.id,
                mode: 'View'
            }
        });
    }

    const onDeleteIconClick = (rowData,isAccessible) => {
        if (!isAccessible) return;
        deleteRuleIdRef.current = rowData?.id,
        setIsDeleteRuleDialogOpen(true);
    }

    /*eslint-disable @typescript-eslint/no-explicit-any*/

    const actionIconsList = useCallback((rule: any) => {
        return (
            [
                {
                    icon: 'rms__view__icon',
                    tooltipText: 'View',
                    fieldId: 'advance-rule-engine-view-btn',
                    className: 'advance__rule__engine__view__icon__wrap',
                    isAccessible: access?.advanceRuleEngineAccess?.view(),
                    action: onViewIconClick
                },
                {
                    icon: 'rms__pencil__icon',
                    tooltipText: 'Edit',
                    fieldId: 'advance-rule-engine-edit-btn',
                    className: 'advance__rule__engine__edit__icon__wrap',
                    isAccessible: access?.advanceRuleEngineAccess?.view(),
                    action: onEditIconClick
                },
                {
                    icon: 'rms__delete__icon',
                    tooltipText: 'Delete',
                    fieldId: 'advance-rule-engine-delete-btn',
                    className: 'advance__rule__engine__delete__icon__wrap',
                    isAccessible: access?.advanceRuleEngineAccess?.view() && rule?.runningStatus === 'Draft' ,
                    action: onDeleteIconClick
                }
            ]
        );
    }, [])

    const derivedConditionActionIconsList = useCallback(() => {
        return (
            [
                {
                    icon: 'rms__view__icon',
                    tooltipText: 'View',
                    fieldId: 'view-derived-condition-btn',
                    className: 'view__derived__condition__icon__wrap',
                    isAccessible: access?.advanceRuleEngineAccess?.view(),
                    action: onViewDerivedConditionClick
                },
                {
                    icon: 'rms__pencil__icon',
                    tooltipText: 'Edit',
                    fieldId: 'edit-derived-condition-btn',
                    className: 'edit__derived__condition__icon__wrap',
                    isAccessible: access?.advanceRuleEngineAccess?.view(),
                    action: onEditDerivedConditionClick
                }
            ]
        );
    }, [])

    const advanceRuleEngineColumns = [
        {
            field: 'runningStatus',
            headerName: '',
            flex: 1,
            maxWidth: 40,
            minWidth: 40,
            align: 'center',
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                const iconClass = advanceRuleEngineStatusMapper?.[rowData?.runningStatus]?.icon
                return (
                    <IconWithTooltip iconClassName={iconClass} toolTipText={rowData?.runningStatus} />
                )
            }
        },
        {
            field: 'error',
            headerName: '',
            flex: 1,
            maxWidth: 40,
            minWidth: 40,
            align: 'center',
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                const iconClass = advanceRuleEngineStatusMapper?.['Error']?.icon
                return (
                    (rowData?.error === 1 ) ? <IconWithTooltip iconClassName={iconClass} toolTipText={'Error'} />
                    : <div>{''}</div> 
                )
            }
        },
        {
            field: 'ruleName',
            headerName: 'Rule Name',
            flex: 1,
            minWidth: 180,
            sortable: true,
            hideable: false,
            pinnable: false,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.ruleName} labelId={'advance__rule__engine__rule__name-' + rowData?.id} />
                )
            },
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 1,
            minWidth: 300,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.description} labelId={'advance__rule__engine__rule__description-' + rowData?.id} />
                );
            },
        },
        {
            field: 'status',
            headerName: 'Enable/Disable',
            flex: 1,
            minWidth: 150,
            renderCell: renderStatusCell,
        },
        {
            field: 'createdBy',
            headerName: 'Created By',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Created At',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): React.ReactNode => {
                const rowData = params?.row;
                return rowData?.createdAt ? formatRelativeTimeForTable(new Date(rowData?.createdAt)) : '-';
            },
        },
        {
            field: 'updatedBy',
            headerName: 'Updated By',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'updatedAt',
            headerName: 'Updated At',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): React.ReactNode => {
                const rowData = params?.row;
                return rowData?.updatedAt ? formatRelativeTimeForTable(new Date(rowData?.updatedAt)) : '-';
            },
        },
        {
            field: 'noofChargers',
            headerName: 'No. Of Chargers',
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
                const rowData = params?.row;
                const count = rowData?.noofChargers ?? 0;
                if (!count) {
                    return (<span style={{ fontWeight: 500 }}>{count || '-'}</span>);
                }
                return (
                    <div
                        className='rule__engine__highlighted__text'
                        onClick={(e) => {
                            e?.stopPropagation();
              
                    navigate('/manage-chargers', { state: { chargerIds: rowData?.scopeChargerIds, isFromRuleEngine: true } });
                        }}
                    >
                        <span style={{ fontWeight: 500 }}>{count}</span>
                    </div>
                );
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            minWidth: 120,
            sortable: false,
            pinnable: false,
            renderCell: (params) => {
                const rowData = params?.row;
                return (
                    <div className='advance__rule__engine__action__icon__wrap'>
                        {
                            actionIconsList(rowData).map(actionBtn => {
                                if (!actionBtn?.isAccessible) return;
                                return (
                                    <div key={actionBtn.fieldId} className={actionBtn.className} onClick={(e) => actionBtn.action(rowData, actionBtn?.isAccessible)}>
                                        <IconWithTooltip iconClassName={actionBtn.icon} toolTipText={actionBtn.tooltipText} />
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
        }
    ]

    const advanceRuleEngineHistoryColumns = [
        {
            field: 'triggerTime',
            headerName: 'Trigger Time',
            renderHeader: ()=>{
                return (
                    <span className='version-releases-column-header'>
                    <span className='version-releases-column-header-text'>Trigger Time</span>
                    <span className='version-releases-column-header-icon'><IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={'Time at which the Trigger Condition is met'}/></span>
                    </span>
                )
            },
            flex: 0.5,
            minWidth: 180,
            sortable: true,
            hideable: false,
            pinnable: false,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): React.ReactNode => {
                const rowData = params?.row;
                const timeDisplay = rowData?.triggerTime ? formatRelativeTimeForTable(new Date(rowData?.triggerTime)) : '-';
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        {rowData?.initialTrigger && (
                            <ThemeProvider theme={TooltipTheme}>
                            <Tooltip
                                title={
                                    rowData?.triggerEventType === 'OfflinePending'
                                        ? 'Initial Trigger Failed on Rule Create or Edit'
                                        : 'Initial Trigger Successful on Rule Create or Edit'
                                }
                                arrow
                            >
                                    <Box sx={{
                                        width: 18,
                                        height: 18,
                                        borderRadius: '50%',
                                        backgroundColor:  rowData?.triggerEventType === 'OfflinePending' ? '#d32f2f' : '#1976d2',
                                        color: '#fff',
                                        fontSize: 11,
                                        fontWeight: 700,
                                        display: 'flex',
                                        cursor:'pointer',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                    }}>
                                        1
                                    </Box>
                                </Tooltip>
                            </ThemeProvider>
                        )}
                        {timeDisplay}
                    </Box>
                );
            },
        },
        {
            field: 'fireTime',
            headerName: 'Fire Time',
            renderHeader: ()=>{
                return (
                    <span className='version-releases-column-header'>
                    <span className='version-releases-column-header-text'>Fire Time</span>
                    <span className='version-releases-column-header-icon'><IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={'Time at which the Action Control is executed'}/></span>
                    </span>
                )
            },
            flex: 0.5,
            minWidth: 180,
            sortable: true,
            hideable: false,
            pinnable: false,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): React.ReactNode => {
                const rowData = params?.row;
                return rowData?.fireTime && rowData?.triggerEventType !== 'OfflinePending' && rowData?.actionStatus !== 'Started' ? formatRelativeTimeForTable(new Date(rowData?.fireTime)) : '-';
            },
        },
        {
            field: 'ruleName',
            headerName: 'Rule Name',
            flex: 1,
            minWidth: 120,
            sortable: true,
            hideable: false,
            pinnable: false,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.ruleName} labelId={'advance__rule__engine__rule__name-' + rowData?.id} />
                )
            },
        },
        {
            field: 'chargerId',
            headerName: 'Charger',
            flex: 1,
            minWidth: 180,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
                const rowData = params?.row;
                return (
                    rowData?.chargerId ?
                        (<div
                            className='rule__engine__highlighted__text'
                            onClick={(e) => {
                                e?.stopPropagation()
                                const action = {
                                    type: chargerTypes.SET_CHARGER_REDUCER_STATE,
                                    isChargerTablePropsRetained: true
                                }
                                dispatch(action)
                            }
                            }
                        >
                            <LinkButton
                                linkBtnId={rowData?.chargerId}
                                link={'/charger?chargerId=' + rowData.chargerId}
                                btnClassName="individual__charger__text"
                                btnText={rowData?.chargerVisibleId}
                                linkBtnState={{ chargerId: rowData?.chargerId, charger: rowData }}
                            />
                        </div>) : (<div onClick={() => setNoChargerDialogOpen(true)}>{rowData?.chargerVisibleId}</div>)
                );
            },
        },
        {
            field: 'connectorType',
            headerName: 'Connector',
            flex: 1,
            minWidth: 120,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
                const rowData = params?.row
                return (
                    <CustomTooltipWithLabel label={rowData?.connectorType} labelId={'advance__rule__engine__connector-' + rowData?.id} />
                )
            }
        },
        {
            field: 'ocppId',
            headerName: 'OCPP Id',
            flex: 1,
            sortable: true,
            pinnable: false,
            minWidth: 120,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
                const rowData = params?.row
                return (
                    <CustomTooltipWithLabel label={rowData?.ocppId} labelId={rowData?.id} />
                )
            }
        },
        {
            field: 'chargingStationName',
            headerName: 'Charging Station',
            flex: 1,
            minWidth: 180,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <div
                        className='rule__engine__highlighted__text'
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate('/station', { state: { id: rowData?.chargingStationId, mode: 'View', stationName: rowData?.chargingStationName, } });
                        }}>
                        <CustomTooltipWithLabel label={rowData?.chargingStationName} labelId={'rule__engine__history__charging__station__name'} />
                    </div>
                )
            },
        },
        {
            field: 'customerName',
            headerName: 'Customer',
            flex: 1,
            minWidth: 180,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <div
                        className='rule__engine__highlighted__text'
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate('/customer', { state: { id: rowData?.customerId, mode: 'View', name: rowData?.customerName } });
                        }}>
                        <CustomTooltipWithLabel label={rowData?.customerName} labelId={'rule__engine__history__customer__name'} />

                    </div>
                )
            },
        },
        {
            field: 'triggerLog',
            headerName: 'Triggered Conditions',
            renderHeader: ()=>{
                return (
                    <span className='version-releases-column-header'>
                    <span className='version-releases-column-header-text'>Triggered Conditions</span>
                    <span className='version-releases-column-header-icon'><IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={'Condition leading to the rule execution'}/></span>
                    </span>
                )
            },
            flex: 1,
            minWidth: 300,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                const triggerLogs = rowData?.triggerLog ? JSON.parse(rowData.triggerLog) : null;
                const conditions = triggerLogs?.triggeredConditions ?? [];
                const label = conditions.join(' , ');
                return (
                    <CustomTooltipWithLabel label={label} labelId={'rule__engine__history__trigger__condition_logs'} />
                )
            },
        },
        {
            field: 'actionStatus',
            headerName: 'Action Controls Status',
            flex: 0.8,
            minWidth: 180,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): JSX.Element => {
                const rowData = params?.row
                const actionStatus = rowData?.actionStatus;
                const status = actionStatus === 'Completed';

                return (
                    <div className='rule__name__status'>
                        {rowData?.actionType && <IconWithTooltip iconClassName={status ? 'status__active__user__icon' : 'status__inactive__user__icon'} />}
                        {rowData?.actionType ?? '-'}
                    </div>
                );
            },
        },
        {
            field: 'parameterName',
            headerName: 'Parameter',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.parameterName} labelId={'rule__engine__history__parameter__name'} />
                )
            },
        },
        {
            field: 'remoteCommand',
            headerName: 'Remote Command',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.remoteCommand} labelId={'rule__engine__history__remote__command__name'} />
                )
            },
        },
        {
            field: 'triggerEventType',
            headerName: 'Remarks',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                const remark  = rowData?.triggerEventType === 'OfflinePending' ? 'Charger is offline' :  ''
                return (
                    <CustomTooltipWithLabel label={remark} labelId={'rule__engine__history__trigger__event_type'} />
                )
            },
        },
    ];

    const derivedConditionsColumns = [
        {
            field: 'name',
            headerName: 'Derived Condition Name',
            flex: 1,
            minWidth: 180,
            sortable: true,
            hideable: false,
            pinnable: false,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.name} labelId={'derived__condition__name-' + rowData?.id} containerClassName={'derived__condition__name__container'} tooltipClickHandler={()=>onViewDerivedConditionClick(rowData,access?.advanceRuleEngineAccess?.view())}/>
                )
            },
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 1,
            minWidth: 300,
            renderCell: (params: GridRenderCellParams<GridValidRowModel, Date>): JSX.Element => {
                const rowData = params?.row;
                return (
                    <CustomTooltipWithLabel label={rowData?.description} labelId={'advance__rule__engine__rule__description-' + rowData?.id} />
                );
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                const value = params?.value === 'Not Draft' ? 'Published' : 'Draft';
                return <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(value)}</span>
            },
        },
        {
            field: 'createdBy',
            headerName: 'Created By',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Created At',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): React.ReactNode => {
                const rowData = params?.row;
                return rowData?.createdAt ? formatRelativeTimeForTable(new Date(rowData?.createdAt)) : '-';
            },
        },
        {
            field: 'updatedBy',
            headerName: 'Updated By',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'updatedAt',
            headerName: 'Updated At',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params: GridRenderCellParams<GridValidRowModel>): React.ReactNode => {
                const rowData = params?.row;
                return rowData?.updatedAt ? formatRelativeTimeForTable(new Date(rowData?.updatedAt)) : '-';
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            minWidth: 120,
            sortable: false,
            pinnable: false,
            renderCell: (params) => {
                const rowData = params?.row;
                return (
                    <div className='advance__rule__engine__action__icon__wrap'>
                        {
                            derivedConditionActionIconsList().map(actionBtn => {
                                if (!actionBtn?.isAccessible && actionBtn?.fieldId === 'edit-derived-condition-btn') return;
                                return (
                                    <div key={actionBtn.fieldId} className={actionBtn.className} onClick={(e) => actionBtn.action(rowData, actionBtn?.isAccessible)}>
                                        <IconWithTooltip iconClassName={actionBtn.icon} toolTipText={actionBtn.tooltipText} />
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
        }
    ]

    const layoutCallback = useCallback(async (pageNumber: number, pageSize: number, view: string, field: string, order: string, filterData, searchTerm) => {
        const tableProps = cloneDeep(advanceRuleEngineListTablePropsRef?.current);
        const filters = filterData ? filterData : getCurrentFiltersValues('advanceRuleEngine', true);
        await dispatch(fetchAdvanceRuleEngineRuleListData(
            {
                view: view ?? 'list',
                sortBy: field || tableProps?.sortBy,
                order: order || tableProps?.order,
                pageSize,
                pageNumber,
                filters: filters,
                searchTerm: searchTerm != null ? searchTerm : tableProps?.searchTerm
            }
        ))
        if (tableProps) {
            tableProps.view = view || 'list';
            tableProps.sortBy = field || tableProps?.sortBy;
            tableProps.order = order || tableProps?.order;
            tableProps.pageNumber = pageNumber;
            tableProps.pageSize = pageSize;
            if (searchTerm != null) {
                tableProps.searchTerm = searchTerm;
            }
        }
        await dispatch(setAdvanceRuleEngineListTableProps(tableProps));
    }, [dispatch]);

    const layoutCallbackHistory = useCallback(async (pageNumber: number, pageSize: number, view: string, field: string, order: string, filterData, searchTerm) => {
        const tableProps = cloneDeep(advanceRuleEngineHistoryListTablePropsRef?.current);
        const filters = filterData ? filterData : getCurrentFiltersValues('advanceRuleEngineHistory');
        await dispatch(fetchAdvanceRuleEngineRuleHistoryListData(
            {
                view: view ?? 'list',
                sortBy: field || tableProps?.sortBy,
                order: order || tableProps?.order,
                pageSize,
                pageNumber,
                filters: filters,
                searchTerm: searchTerm != null ? searchTerm : tableProps?.searchTerm,
                fetchAllTriggers: showAllTriggers
            }
        ))
        if (tableProps) {
            tableProps.view = view || 'list';
            tableProps.sortBy = field || tableProps?.sortBy;
            tableProps.order = order || tableProps?.order;
            tableProps.pageNumber = pageNumber;
            tableProps.pageSize = pageSize;
            if (searchTerm != null) {
                tableProps.searchTerm = searchTerm;
            }
        }
        await dispatch(setAdvanceRuleEngineHistoryListTableProps(tableProps));
    }, [dispatch, showAllTriggers]);

    const layoutCallbackDerivedConditions = useCallback(async (pageNumber: number, pageSize: number, view: string, field: string, order: string, filterData, searchTerm) => {
        const tableProps = cloneDeep(derivedConditionsListTablePropsRef?.current);
        const filters = filterData ? filterData : getCurrentFiltersValues('derivedConditions',true);
        await dispatch(fetchDerivedConditionsListData(
            {
                view: view ?? 'list',
                sortBy: field || tableProps?.sortBy,
                order: order || tableProps?.order,
                pageSize,
                pageNumber,
                filters: filters,
                searchTerm: searchTerm != null ? searchTerm : tableProps?.searchTerm
            }
        ))
        if (tableProps) {
            tableProps.view = view || 'list';
            tableProps.sortBy = field || tableProps?.sortBy;
            tableProps.order = order || tableProps?.order;
            tableProps.pageNumber = pageNumber;
            tableProps.pageSize = pageSize;
            if (searchTerm != null) {
                tableProps.searchTerm = searchTerm;
            }
        }
        await dispatch(setDerivedConditionsListTableProps(tableProps));
    }, [dispatch]);

    const navConfig = {
        'advanceRuleEngine': {
            tablePropsRef: advanceRuleEngineListTablePropsRef,
            layoutCallbackFn: layoutCallback,
            excludeGlobalFilters: true,
            setTableProps: setAdvanceRuleEngineListTableProps
        },
        'advanceRuleEngineHistory': {
            tablePropsRef: advanceRuleEngineHistoryListTablePropsRef,
            layoutCallbackFn: layoutCallbackHistory,
            excludeGlobalFilters: false,
            setTableProps: setAdvanceRuleEngineHistoryListTableProps
        },
        'derivedConditions': {
            tablePropsRef: derivedConditionsListTablePropsRef,
            layoutCallbackFn: layoutCallbackDerivedConditions,
            excludeGlobalFilters: true,
            setTableProps: setDerivedConditionsListTableProps
        }
    }

    const handleFilterDataChange = useCallback(async (data, filterKey: string, isGlobal: boolean) => {
        const tableProps = cloneDeep(navConfig?.[selectedNav]?.tablePropsRef?.current);
        const res = await setFilterData(data, filterKey, selectedNav, 'SET', isGlobal, navConfig?.[selectedNav]?.excludeGlobalFilters)(dispatch);
        if (res?.message === 'Action dispatched successfully') {
            await navConfig?.[selectedNav]?.layoutCallbackFn(
                1,
                tableProps?.pageSize,
                tableProps?.view,
                tableProps?.sortBy,
                tableProps?.order,
                res?.filters,
                tableProps?.searchTerm ?? '',
            )
        }
    }, [selectedNav, navConfig])


    const advanceRuleEngineFilterProps: FilterProp[] = useMemo(() => {
        const advanceRuleEngineCreatedAtValue = getFilterSelectedValue('advanceRuleEngineCreatedAtInterval', 'advanceRuleEngine', false);
        const advanceRuleEngineUpdatedAtValue = getFilterSelectedValue('advanceRuleEngineUpdatedAtInterval', 'advanceRuleEngine', false);
        const advanceRuleEngineFireTimeRangeValue = getFilterSelectedValue('advanceRuleEngineFireTimeRangeInterval', 'advanceRuleEngineHistory', false);
        const derivedConditionCreatedAtValue = getFilterSelectedValue('derivedConditionCreatedAtInterval', 'derivedConditions', false);
        const derivedConditionUpdatedAtValue = getFilterSelectedValue('derivedConditionUpdatedAtInterval', 'derivedConditions', false);

        if (selectedNav === 'advanceRuleEngine') {
            return ([
                {
                    filterLabel: 'Status',
                    filterType: 'dropdown',
                    filterId: 'advanceRuleEngineStatus',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('advanceRuleEngineStatus', 'advanceRuleEngine', false),
                        selectOptions: ruleEngineStatusReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'advanceRuleEngineStatus', false)
                        },
                        selectDropDownId: 'advance-rule-engine-status-filter-dropdown',
                        isMultiSelect: false
                    }
                },
                {
                    filterLabel: 'Created By',
                    filterId: 'advanceRuleEngineCreatedBy',
                    filterType: 'dropdown',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('advanceRuleEngineCreatedBy', 'advanceRuleEngine', false),
                        selectOptions: userReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'advanceRuleEngineCreatedBy', false);
                        },
                        selectDropDownId: 'advance-rule-engine-created-by-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Updated By',
                    filterId: 'advanceRuleEngineUpdatedBy',
                    filterType: 'dropdown',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('advanceRuleEngineUpdatedBy', 'advanceRuleEngine', false),
                        selectOptions: userReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'advanceRuleEngineUpdatedBy', false);
                        },
                        selectDropDownId: 'advance-rule-engine-updated-by-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Created At',
                    filterId: 'advanceRuleEngineCreatedAtInterval',
                    filterType: 'dateFilter',
                    dateFilterProps: {
                        datePickerId: 'advance-rule-engine-created-at-date-picker',
                        datePickerClassName: '',
                        selectsRange: true,
                        startDate: advanceRuleEngineCreatedAtValue?.[0]
                            ? new Date(advanceRuleEngineCreatedAtValue?.[0])
                            : null,
                        endDate: advanceRuleEngineCreatedAtValue?.[1]
                            ? new Date(advanceRuleEngineCreatedAtValue?.[1])
                            : null,
                        onChange: (val): void => {
                            handleFilterDataChange(val, 'advanceRuleEngineCreatedAtInterval', false);
                        },
                    }
                },
                {
                    filterLabel: 'Updated At',
                    filterId: 'advanceRuleEngineUpdatedAtInterval',
                    filterType: 'dateFilter',
                    dateFilterProps: {
                        datePickerId: 'advance-rule-engine-updated-at-date-picker',
                        datePickerClassName: '',
                        selectsRange: true,
                        startDate: advanceRuleEngineUpdatedAtValue?.[0]
                            ? new Date(advanceRuleEngineUpdatedAtValue?.[0])
                            : null,
                        endDate: advanceRuleEngineUpdatedAtValue?.[1]
                            ? new Date(advanceRuleEngineUpdatedAtValue?.[1])
                            : null,
                        onChange: (val): void => {
                            handleFilterDataChange(val, 'advanceRuleEngineUpdatedAtInterval', false);
                        },
                    }
                }
            ])
        }
        else if (selectedNav === 'advanceRuleEngineHistory') {
            return ([
                {
                    filterLabel: 'Charging Stations',
                    filterType: 'dropdown',
                    filterId: 'chargingStationId',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('chargingStationId', 'advanceRuleEngineHistory', false),
                        selectOptions: chargingStationReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'chargingStationId', false)
                        },
                        selectDropDownId: 'advance-rule-engine-history-chargingStationId-type-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Chargers',
                    filterType: 'dropdown',
                    filterId: 'chargerId',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('chargerId', 'advanceRuleEngineHistory', false),
                        selectOptions: chargerVisibleIdReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'chargerId', false)
                        },
                        selectDropDownId: 'advance-rule-engine-history-chargerId-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Rule Name',
                    filterType: 'dropdown',
                    filterId: 'advaneRuleEngineRuleName',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('advaneRuleEngineRuleName', 'advanceRuleEngineHistory', false),
                        selectOptions: advanceRuleEngineRuleNameReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'advaneRuleEngineRuleName', false)
                        },
                        selectDropDownId: 'advance-rule-engine-history-ruleName-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Fire Time',
                    filterId: 'advanceRuleEngineFireTimeRangeInterval',
                    filterType: 'dateFilter',
                    dateFilterProps: {
                        datePickerId: 'advance-rule-engine-fire-time-date-picker',
                        datePickerClassName: '',
                        selectsRange: true,
                        startDate: advanceRuleEngineFireTimeRangeValue?.[0]
                            ? new Date(advanceRuleEngineFireTimeRangeValue?.[0])
                            : null,
                        endDate: advanceRuleEngineFireTimeRangeValue?.[1]
                            ? new Date(advanceRuleEngineFireTimeRangeValue?.[1])
                            : null,
                        onChange: (val): void => {
                            handleFilterDataChange(val, 'advanceRuleEngineFireTimeRangeInterval', false);
                        },
                    }
                }
            ])
        }
        else {
            return ([
                {
                    filterLabel: 'Status',
                    filterType: 'dropdown',
                    filterId: 'derivedConditionStatus',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('derivedConditionStatus', 'derivedConditions', false),
                        selectOptions: derivedConditionStatusRef ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'derivedConditionStatus', false)
                        },
                        selectDropDownId: 'derived-conditions-status-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Created By',
                    filterId: 'derivedConditionCreatedBy',
                    filterType: 'dropdown',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('derivedConditionCreatedBy', 'derivedConditions', false),
                        selectOptions: userReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'derivedConditionCreatedBy', false);
                        },
                        selectDropDownId: 'derived-conditions-created-by-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Updated By',
                    filterId: 'derivedConditionUpdatedBy',
                    filterType: 'dropdown',
                    filterDropdownProps: {
                        selectValue: getFilterSelectedValue('derivedConditionUpdatedBy', 'derivedConditions', false),
                        selectOptions: userReferenceData ?? [],
                        handleSelectOptionChange: (val): void => {
                            handleFilterDataChange(val, 'derivedConditionUpdatedBy', false);
                        },
                        selectDropDownId: 'derived-conditions-updated-by-filter-dropdown',
                        isMultiSelect: true
                    }
                },
                {
                    filterLabel: 'Created At',
                    filterId: 'derivedConditionCreatedAtInterval',
                    filterType: 'dateFilter',
                    dateFilterProps: {
                        datePickerId: 'derived-conditions-created-at-date-picker',
                        datePickerClassName: '',
                        selectsRange: true,
                        startDate: derivedConditionCreatedAtValue?.[0]
                            ? new Date(derivedConditionCreatedAtValue?.[0])
                            : null,
                        endDate: derivedConditionCreatedAtValue?.[1]
                            ? new Date(derivedConditionCreatedAtValue?.[1])
                            : null,
                        onChange: (val): void => {
                            handleFilterDataChange(val, 'derivedConditionCreatedAtInterval', false);
                        },
                    }
                },
                {
                    filterLabel: 'Updated At',
                    filterId: 'derivedConditionUpdatedAtInterval',
                    filterType: 'dateFilter',
                    dateFilterProps: {
                        datePickerId: 'derived-condtions-updated-at-date-picker',
                        datePickerClassName: '',
                        selectsRange: true,
                        startDate: derivedConditionUpdatedAtValue?.[0]
                            ? new Date(derivedConditionUpdatedAtValue?.[0])
                            : null,
                        endDate: derivedConditionUpdatedAtValue?.[1]
                            ? new Date(derivedConditionUpdatedAtValue?.[1])
                            : null,
                        onChange: (val): void => {
                            handleFilterDataChange(val, 'derivedConditionUpdatedAtInterval', false);
                        },
                    }
                }
            ])
        }
    }, [selectedNav, screenFilters, userReferenceData, ruleEngineStatusReferenceData, chargingStationReferenceData, chargerVisibleIdReferenceData, advanceRuleEngineRuleNameReferenceData, handleFilterDataChange]);


    const onChangeOfSearchText = useCallback(async (searchText) => {
        const trimmedSearchText = searchText.trim();
        const tableProps = cloneDeep(navConfig[selectedNav]?.tablePropsRef?.current);
        const filters = getCurrentFiltersValues(selectedNav,navConfig[selectedNav]?.excludeGlobalFilters);
        if (tableProps) {
            tableProps.searchTerm = trimmedSearchText;
        }
        await navConfig[selectedNav]?.layoutCallbackFn(
            1,
            tableProps?.pageSize,
            tableProps?.view,
            tableProps?.sortBy,
            tableProps?.order,
            filters,
            trimmedSearchText,
        )
    }, [layoutCallback, layoutCallbackHistory, selectedNav, navConfig]);

    const searchBoxConfiguration = useMemo(() => {
        return {
            searchFieldId: 'manage-advance-rule-engine-search-box',
            searchFieldName: 'manage-advance-rule-engine-search-box',
            searchBoxClassName: 'manage-advance-rule-engine-search-box',
            handleSearch: onChangeOfSearchText,
        };
    }, [onChangeOfSearchText]);


    const getAdvanceRuleEngineTableRows = useCallback((): IAdvanceRuleEngineListItem[] => {
        return advanceRuleEngineRuleList !== null && advanceRuleEngineRuleList?.length > 0 ? advanceRuleEngineRuleList : [];
    }, [advanceRuleEngineRuleList]);

    const getAdvanceRuleEngineHistoryTableRows = useCallback((): IAdvanceRuleEngineHistoryListItem[] => {
        return advanceRuleEngineRuleHistoryList !== null && advanceRuleEngineRuleHistoryList?.length > 0 ? advanceRuleEngineRuleHistoryList : [];
    }, [advanceRuleEngineRuleHistoryList])

    const getDerivedConditionsTableRows = useCallback((): IDerivedConditionListItem[] => {
        return derivedConditionsList !== null && derivedConditionsList?.length > 0 ? derivedConditionsList : [];
    }, [derivedConditionsList])

    useLayoutEffect(() => {
        const calculateTableWrapHeight = (): void => {
            if (
                headerWrapRef?.current &&
                searchWrapRef?.current &&
                tableWrapRef?.current &&
                subHeaderRef?.current
            ) {
                const totalHeight = tableWrapRef.current.getBoundingClientRect().height;
                const headerHeight = headerWrapRef.current.getBoundingClientRect().height;
                const searchHeight = searchWrapRef.current.getBoundingClientRect().height;
                const subHeaderHeight = subHeaderRef?.current?.getBoundingClientRect?.().height ?? 0;
                const infoTextHeight = infoTextWrapRef?.current?.getBoundingClientRect?.().height ?? 0;

                const tableWrapHeight = totalHeight - headerHeight - searchHeight - subHeaderHeight - infoTextHeight;

                setTableWrapHeight(tableWrapHeight);
            }
        }

        calculateTableWrapHeight();

        const resizeObserver = new ResizeObserver(() => {
            calculateTableWrapHeight();
        })

        if (tableWrapRef?.current) resizeObserver?.observe(tableWrapRef?.current);
        if (headerWrapRef?.current) resizeObserver?.observe(headerWrapRef?.current);
        if (searchWrapRef?.current) resizeObserver?.observe(searchWrapRef?.current);
        if (subHeaderRef?.current) resizeObserver?.observe(subHeaderRef?.current);
        if (infoTextWrapRef?.current) resizeObserver?.observe(infoTextWrapRef?.current);

        return () => {
            resizeObserver.disconnect();
        }
    }, []);

    const advanceRuleEngineNavList = [
        {
            id: 'advanceRuleEngine',
            text: 'Rules',
            isAccessible: true
        },
        {
            id: 'advanceRuleEngineHistory',
            text: 'History',
            isAccessible: true
        },
        {
            id: 'derivedConditions',
            text: 'Derived Conditions',
            isAccessible: true
        }
    ];

    const handleNavBtnClick = useCallback((val) => {
        setSelectedNav(val);
        const tableProps = cloneDeep(navConfig[val]?.tablePropsRef?.current);
        tableProps.searchTerm = '';
        dispatch(navConfig[val]?.setTableProps(tableProps));
    }, [dispatch,navConfig])

    const navBarconfigurations = useMemo(() => {
        return {
            selectedNav: selectedNav,
            navList: advanceRuleEngineNavList?.filter((nav) => nav?.isAccessible),
            onNavClick: handleNavBtnClick
        }
    }, [selectedNav, handleNavBtnClick]);

    const handleFiltersClosePopOver = (): void => {
        setFiltersVisible(false);
    }

    const onResetButtonClick = useCallback(async (callList: boolean) => {
        const tab = selectedNav ?? 'advanceRuleEngine';
        const res = await setFilterData(null, '', tab, 'CLEAR', true, navConfig[selectedNav]?.excludeGlobalFilters)(dispatch);
        if (res?.message === 'Action dispatched successfully') {
            //RESET FILTERS
            if(callList && navConfig[selectedNav]?.tablePropsRef?.current) {
                const tableProps = cloneDeep(navConfig[selectedNav]?.tablePropsRef?.current);
                await navConfig[selectedNav]?.layoutCallbackFn(
                    1,
                    tableProps?.pageSize,
                    tableProps?.view,
                    tableProps?.sortBy,
                    tableProps?.order,
                    res?.filters,
                    tableProps?.searchTerm ?? '',
                )
            }
        }

    }, [selectedNav,navConfig])

    const filterFooterBtns = useMemo(() => {
        return [
            {
                buttonText: 'Reset',
                buttonId: 'Reset',
                btnClassName: 'secondary__btn',
                handleClick: (): Promise<void> => onResetButtonClick(true),
                isDisabled: false,
                buttonVariant: 'outlined',
            },
        ];
    }, [onResetButtonClick]);


    const onExportBtnClick = useCallback(async (fileType: 'csv' | 'xlsx'): Promise<void> => {
        if (exportingFile) {
            // If already exporting, prevent another export
            return;
        }
        try {
            const response: AxiosResponse = await dispatch(exportAdvanceRuleEngineHistoryData({
                fileType,
                sortBy: advanceRuleEngineHistoryListTablePropsRef?.current?.sortBy,
                order: advanceRuleEngineHistoryListTablePropsRef?.current?.order,
                filters: getCurrentFiltersValues('advanceRuleEngineHistory')
            }));

            if (response?.status === 202 || response?.status === 200) {
                downloadFile({ url: response?.data?.url });
                successToast('Rule Engine logs downloaded.');
            } else {
                errorToast('Something went wrong. Please export again.');
                setExportAnchorEl(null);
            }
        } finally {
            // Ensure that exporting status is updated even if there's an error
            setExportingFile(false);
            setExportAnchorEl(null);

        }
    }, [exportingFile, successToast, errorToast, selectedNav])

    const handleClose = () => {
        setExportAnchorEl(null)
    }

    // Cleans Up table props when component unmounts
    const advanceRuleEngineCleanUpStates = useCallback(() => {
        const action = {
            type: advanceRuleEngineTypes.CLEAR_ADVANCE_RULE_ENGINE_DASHBOARD
        }
        dispatch(action);
    }, [])

    useEffect(() => {
        window.addEventListener('beforeunload', advanceRuleEngineCleanUpStates);
        return (): void => {
            advanceRuleEngineCleanUpStates()
            window.removeEventListener('beforeunload', advanceRuleEngineCleanUpStates);
        }
    }, [])

    useEffect(() => {
        if (selectedNav === 'advanceRuleEngineHistory') {
            layoutCallbackHistory(
                advanceRuleEngineHistoryListTablePropsRef?.current?.pageNumber,
                advanceRuleEngineHistoryListTablePropsRef?.current?.pageSize,
                advanceRuleEngineHistoryListTablePropsRef?.current?.view,
                advanceRuleEngineHistoryListTablePropsRef?.current?.sortBy,
                advanceRuleEngineHistoryListTablePropsRef?.current?.order,
                null,
                advanceRuleEngineHistoryListTablePropsRef?.current?.searchTerm
            )
        }
    }, [showAllTriggers])

    const handleClick = (val: string):void => {
        setSelectedChip(val);
        const label = startCase(val);
        const statusFilterValue = {id: val, label: label, name: label, value: val}
        handleFilterDataChange(statusFilterValue, 'advanceRuleEngineStatus', false)
    }

    const quickFilterChips = [
        {
            chipId: 'all',
            chipTitle: 'All',
            selectedChipIcon: 'rule_engine_all_status_icon_selected',
            chipIcon: 'rule_engine_all_status_icon',
            onClick: () => {handleClick('all')}
        },
        {
            chipId: 'Running',
            chipTitle: 'Running',
            selectedChipIcon: 'rule_engine_running_status_icon_selected',
            chipIcon: 'rule_engine_running_status_icon',
            onClick: () => {handleClick('Running')}
        },
        {
            chipId: 'Stopped',
            chipTitle: 'Stopped',
            selectedChipIcon: 'rule_engine_stopped_status_icon_selected',
            chipIcon: 'rule_engine_stopped_status_icon',
            onClick: () => {handleClick('Stopped')}
        },
        {
            chipId: 'Error',
            chipTitle: 'Error',
            selectedChipIcon: 'rule_engine_error_status_icon_selected',
            chipIcon: 'rule_engine_error_status_icon',
            onClick: () => {handleClick('Error')}
        },
        {
            chipId: 'Draft',
            chipTitle: 'Draft',
            selectedChipIcon: 'rule_engine_draft_status_icon_selected',
            chipIcon: 'rule_engine_draft_status_icon',
            onClick: () => {handleClick('Draft')}
        }
    ];

    /* Delete Rule functions */

    const handleDeleteDialogClose = () => {
        setIsDeleteRuleDialogOpen(false);
    }

    const handleDeleteRule = async () => {
        setShowLoader(true);
        handleDeleteDialogClose();
        const ruleId = deleteRuleIdRef?.current;
        const res = await dispatch(deleteAdvanceRuleEngineRule(ruleId));
        if (res?.status === 200 || res?.status === 202){
            await layoutCallback(
                1,
                advanceRuleEngineListTablePropsRef?.current?.pageSize,
                advanceRuleEngineListTablePropsRef?.current?.view,
                advanceRuleEngineListTablePropsRef?.current?.sortBy,
                advanceRuleEngineListTablePropsRef?.current?.order,
                null,
                advanceRuleEngineListTablePropsRef?.current?.searchTerm
            )
            setShowLoader(false);
            successToast('Rule deleted.');
        }else {
            setShowLoader(false);
            errorToast(res?.data?.message ?? 'Something went wrong.');
        } 
    }

    const handleLayoutToggle = useCallback(async (val: string) => {
        await dispatch(setAdvanceRuleEngineLayoutView(val));
        setLayoutView(val);
      }, [])

    const layoutConfiguration = useMemo(() => {
        return [
          {
            toolTipText: 'List View',
            onIconClick: (): void => {
              handleLayoutToggle('list')
            },
            layout: 'list',
            iconClassName: 'configure__notification__header__list__icon'
          },
          {
            toolTipText: 'Grid View',
            onIconClick: (): void => {
              handleLayoutToggle('grid')
            },
            layout: 'grid',
            iconClassName: 'configure__notification__header__grid__icon'
          },
        ]
      }, [handleLayoutToggle])

    const handlePageSizeChange =  (pageSize: number) => {
       layoutCallback(
            advanceRuleEngineListTablePropsRef?.current?.pageNumber,
            pageSize,
            advanceRuleEngineListTablePropsRef?.current?.view,
            advanceRuleEngineListTablePropsRef?.current?.sortBy,
            advanceRuleEngineListTablePropsRef?.current?.order,
            null,
            advanceRuleEngineListTablePropsRef?.current?.searchTerm
        )
    }

    const handlePageNumberChange =  (pageNumber: number) => {
       layoutCallback(
            pageNumber,
            advanceRuleEngineListTablePropsRef?.current?.pageSize,
            advanceRuleEngineListTablePropsRef?.current?.view,
            advanceRuleEngineListTablePropsRef?.current?.sortBy,
            advanceRuleEngineListTablePropsRef?.current?.order,
            null,
            advanceRuleEngineListTablePropsRef?.current?.searchTerm
        )
    }

    // To fetch latest rule list whenever grid card updates some rule

    const handleFetchRules = () => {
        layoutCallback(
            advanceRuleEngineListTablePropsRef?.current?.pageNumber, advanceRuleEngineListTablePropsRef?.current?.pageSize, advanceRuleEngineListTablePropsRef?.current?.view, advanceRuleEngineListTablePropsRef?.current?.sortBy, advanceRuleEngineListTablePropsRef?.current?.order, null, advanceRuleEngineListTablePropsRef?.current?.searchTerm
        )
    }

    return (
        <>
            <DashboardLoader showLoader={showLoader} />
            <ThemeProvider theme={TableDashboardTheme}>
                <div className='advance__rule__engine__dashboard__table__wrap' ref={tableWrapRef}>
                    <div className='advance__rule__engine__dashboard__header__wrap' ref={headerWrapRef}>
                        <DashboardHeader
                            headerClassName={'advance__rule__engine__dashboard-header'}
                            header={selectedNav === 'advanceRuleEngine' ? 'All Rules' : 'Rule Executions'}
                        />
                        <div className='advance__rule__engine__dashboard-sub-header'>
                            <TableSubHeader headerActionBtns={headerActionBtns} />
                            {
                                selectedNav === 'advanceRuleEngine' && <div className='advance__rule__engine__dashboard__layout__btns__container'>
                                    {
                                        layoutConfiguration?.map(item => {
                                            return (
                                                <IconWithTooltip
                                                    key={item.layout}
                                                    toolTipText={item.toolTipText}
                                                    onIconClick={() => item?.onIconClick?.()}
                                                    iconClassName={
                                                        layoutView === item.layout
                                                        ? item.iconClassName + ' selected'
                                                        : item.iconClassName ?? ''
                                                    }
                                                />
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div className='advance__rule___engine__info__text' ref={infoTextWrapRef}>
                        Rule Engine can perform multiple fetches and transformations in a single rule.
                    </div>
                    <div className='advance__rule__engine__search__wrap' ref={searchWrapRef}>
                        <div className='advance__rule__engine__search__wrap-left'>
                            <SearchBox
                                key={'searchBox-' + selectedNav}
                                searchFieldId={searchBoxConfiguration?.searchFieldId ?? ''}
                                searchFieldName={searchBoxConfiguration?.searchFieldName ?? ''}
                                searchBoxClassName={searchBoxConfiguration?.searchBoxClassName ?? ''}
                                handleSearch={searchBoxConfiguration?.handleSearch}
                            />
                        </div>
                        {
                            selectedNav === 'advanceRuleEngineHistory' && (
                                <div className='advance__rule__engine__search__wrap-right'>
                                    <div className='toggle__switch__config'>
                                        <IconWithTooltip
                                            iconClassName='rms_info_icon-black'
                                            toolTipText='Shows all trigger logs with no action controls and initial trigger failures during rule creation or update are shown.'
                                            containerClassName='dasboard-toggle-switch-info'
                                        />
                                        <CustomSwitch
                                            switchId='advance__rule__engine__history__show__all__triggers__switch'
                                            switchClassName='advance__rule__engine__history__show__all__triggers__switch'
                                            checked={showAllTriggers}
                                            disableSwitchLabelName='All Trigger Logs'
                                            handleClick={() => setShowAllTriggers(prev => !prev)}
                                            isDisabled={false}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        {
                            selectedNav === 'advanceRuleEngine' && <div className='advance__rule__engine__search__wrap-right'>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    {
                                        quickFilterChips?.map(chip => {
                                            return (
                                                <Chip
                                                    key={chip?.chipId}
                                                    icon={<IconWithTooltip iconClassName={selectedChip === chip?.chipId ? chip?.selectedChipIcon : chip?.chipIcon}/>}
                                                    label={chip?.chipTitle}
                                                    clickable
                                                    variant={(selectedChip === chip?.chipId) ? 'filled' : 'outlined'}
                                                    onClick={chip?.onClick}
                                                    sx={{ 
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderRadius: '16px',
                                                    paddingTop: '2px',
                                                    paddingLeft: '10px',
                                                    paddingRight: '10px',
                                                    fontSize: '12px',
                                                    color: (selectedChip === chip?.chipId) ? '#fff' : 'unset',
                                                    backgroundColor: (selectedChip === chip?.chipId) ? '#06BFBF' : 'unset', 
                                                    '&:hover': {
                                                        backgroundColor: (selectedChip === chip?.chipId) ? '#06BFBF' : 'rgba(0, 0, 0, 0.08)',
                                                    },
                                                    '& .MuiChip-label': {
                                                        paddingBottom: '4px',
                                                        paddingLeft: '8px !important',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    },
                                                    '& .MuiChip-filled': {
                                                        backgroundColor: '#06BFBF', 
                                                    },
                                                    }}
                                                />
                                            )
                                        })
                                    }
                                </Box>
                            </div>
                        }
                    </div>
                    <div className='advance__rule__engine__sub-header__wrap' ref={subHeaderRef}>
                        <HorizontalNavbar
                            selectedNav={navBarconfigurations?.selectedNav}
                            onNavClick={(event, val) => { event?.stopPropagation(); navBarconfigurations?.onNavClick?.(val) }}
                            navList={navBarconfigurations?.navList}
                        />
                    </div>
                    <div className='advance__rule__engine__table__dashboard__wrap' style={{ height: `${tableWrapHeight}px` }}>
                        {
                            selectedNav === 'advanceRuleEngine' ?
                                layoutView === 'list' ? 
                                    <TableLayout
                                        key={'advance__rule__engine__table'}
                                        gridColumns={advanceRuleEngineColumns}
                                        tableRows={getAdvanceRuleEngineTableRows()}
                                        tableId={'advance-rule-engine-table'}
                                        tableClassName={'advance__rule__engine__table'}
                                        layoutView={'list'}
                                        listLayoutCallBack={layoutCallback}
                                        totalCount={advanceRuleEngineListCount}
                                        showLoader={advanceRuleEngineListLoader}
                                        showSkeleton={!advanceRuleEngineRuleList}
                                        totalCountText={'Rules'}
                                        customNoDataComponent={NoDataComponentRuleEngine}
                                        pageNumber={advanceRuleEngineListTableProps?.pageNumber}
                                        tablePageSize={advanceRuleEngineListTableProps?.pageSize}
                                        sortField={advanceRuleEngineListTableProps?.sortBy}
                                        sortOrder={advanceRuleEngineListTableProps?.order}
                                        leftPinnedColumns={['runningStatus', 'error', 'ruleName']}
                                    />
                                    :
                                    <AdvanceRuleEngineGrid
                                        list={getAdvanceRuleEngineTableRows()}
                                        layoutCallback={handleFetchRules} 
                                        handleDeleteRule={onDeleteIconClick}
                                        totalCount={advanceRuleEngineListCount}
                                        totalCountText={'Rules'}
                                        pageNumber={advanceRuleEngineListTableProps?.pageNumber}
                                        tablePageSize={advanceRuleEngineListTableProps?.pageSize}
                                        handlePageSizeChange={handlePageSizeChange}
                                        handlePageNumberChange={handlePageNumberChange}
                                    />

                                :
                                selectedNav === 'advanceRuleEngineHistory' ?
                                <TableLayout
                                    key={'advance__rule__engine__history__table'}
                                    gridColumns={advanceRuleEngineHistoryColumns}
                                    tableRows={getAdvanceRuleEngineHistoryTableRows()}
                                    tableId={'advance-rule-engine-history-table'}
                                    tableClassName={'advance__rule__engine__history__table'}
                                    layoutView={'list'}
                                    listLayoutCallBack={layoutCallbackHistory}
                                    totalCount={advanceRuleEngineHistoryListCount}
                                    showLoader={advanceRuleEngineListLoader}
                                    showSkeleton={!advanceRuleEngineRuleHistoryList}
                                    totalCountText={'Rules'}
                                    customNoDataComponent={NoDataComponentRuleEngineHistory}
                                    pageNumber={advanceRuleEngineHistoryListTableProps?.pageNumber}
                                    tablePageSize={advanceRuleEngineHistoryListTableProps?.pageSize}
                                    sortField={advanceRuleEngineHistoryListTableProps?.sortBy}
                                    sortOrder={advanceRuleEngineHistoryListTableProps?.order}
                                    leftPinnedColumns={['triggerTime','fireTime', 'ruleName']}
                                />
                                :
                                <TableLayout
                                    key={'advance__derived__conditions__table'}
                                    gridColumns={derivedConditionsColumns}
                                    tableRows={getDerivedConditionsTableRows()}
                                    tableId={'advance-derivedp-conditions-table'}
                                    tableClassName={'advance__derived__conditions__table'}
                                    layoutView={'list'}
                                    listLayoutCallBack={layoutCallbackDerivedConditions}
                                    totalCount={derivedConditionsListCount}
                                    showLoader={advanceRuleEngineListLoader}
                                    showSkeleton={!derivedConditionsList}
                                    totalCountText={'Derived Conditions'}
                                    customNoDataComponent={NoDataComponentDerivedConditions}
                                    pageNumber={derivedConditionsListTableProps?.pageNumber}
                                    tablePageSize={derivedConditionsListTableProps?.pageSize}
                                    sortField={derivedConditionsListTableProps?.sortBy}
                                    sortOrder={derivedConditionsListTableProps?.order}
                                    leftPinnedColumns={[]}
                                />
                        }
                    </div>

                </div>
            </ThemeProvider>
            <CustomDialog
                dialogConfig={{
                    dialogDescription: 'Charger information is not available, as the charger has not yet communicated with RMS.',
                    dialogOkTitle: 'Close',
                }}
                show={noChargerDialogOpen}
                handleSubmit={() => { setNoChargerDialogOpen(false) }}
            />
            <>
                {
                    filtersVisible && <SidePopover
                        id={'advance__rule__engine-filters'}
                        open={filtersVisible}
                        containerClassName={'advance-rule-engine-side-filters'}
                        handleClose={handleFiltersClosePopOver}
                        headerText={'Add Filters'}
                        // eslint-disable-next-line react/no-children-prop
                        children={<FilterLayout requiredReferenceDataCallbacks={['advanceRuleEngineStatus', 'chargingStationId', 'chargerVisibleId', 'user', 'advaneRuleEngineRuleName']}
                            filters={advanceRuleEngineFilterProps} handleFilterDataChange={handleFilterDataChange}
                            excludeGlobalFilters={navConfig[selectedNav]?.excludeGlobalFilters}
                        />}
                        btnsList={filterFooterBtns}
                    />
                }
            </>
            <>
                <Menu
                    id="export-option-dropdown"
                    anchorEl={exportAnchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    className='export__option__dropdown'
                    sx={{ top: '30px' }}
                    open={Boolean(exportAnchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem>
                        <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('csv') }}>
                            To CSV
                        </div>
                    </MenuItem>
                    <MenuItem>

                        <div className='export__btn-option' onClick={(e) => {
                            e?.stopPropagation();
                            onExportBtnClick('xlsx')
                        }}>
                            To Excel
                        </div>
                    </MenuItem>
                </Menu>
            </>
            <>
                <CustomDialog
                    dialogConfig={{
                        dialogDescription: 'Are you sure you want to delete this rule?',
                        dialogCancelTitle: 'Cancel',
                        dialogOkTitle: 'Delete',
                    }}
                    show={isDeleteRuleDialogOpen}
                    handleClose={handleDeleteDialogClose}
                    handleSubmit={handleDeleteRule}
                    deleteLoader={showLoader}
                    />
            </>
        </>
    )
}

export default AdvanceRuleEngineDashboard